import { useRef, useEffect } from "react";

export const usePreviousPath = (history, location) => {
  const previousPath = useRef(null);

  useEffect(() => {
    const unlisten = history.listen((newLocation, action) => {
      previousPath.current = location.pathname;
    });

    return () => {
      unlisten();
    };
  }, [history, location]);

  return previousPath.current;
};
